import cn from 'classnames'
import React from 'react'
import { HtmlContentViewer } from 'src/components/global/HtmlContentViewer/HtmlContentViewer'

import VendorLogo from '../../VendorList/VendorListItem/VendorLogo'

export interface EventListItemProps {
  title: string
  logo: string
  description: string
  date: string
  updated_at: string
  city: string
  country: string
  className?: string
  onClick?: () => void
}
export const EventListItem: React.FC<EventListItemProps> = ({
  title,
  logo,
  description,
  date,

  city,
  country,
  className,

  ...props
}) => {
  return (
    <div className={cn('flex', 'flex-row', 'cursor-pointer', 'items-center', 'py-[1.1875rem]', className)} {...props}>
      <div className="flex flex-row cursor-pointer items-center md:pl-[0rem] md:pr-[0rem] pl-[1.25rem] pr-[1.25rem]">
        <VendorLogo
          className="bg-white rounded-[.5rem] drop-shadow-md mr-[1.75rem] md:min-w-[120px] md:w-[120px] md:h-[120px] min-w-[80px] w-[80px] h-[80px] flex items-center justify-center"
          src={logo}
        />
        <div className="grow">
          <div className="w-full flex flex-grow justify-between">
            <div className="w-full flex flex-row justify-between">
              <div className="md:text-[1.125rem] text-[1.0rem] text-textdark font-secondary font-bold mb-1.5">
                {title}
              </div>
            </div>
          </div>
          <div className="flex flex-row  mb-1.5">
            <div className="pr-[2rem] text-textdark text-[0.8125rem] font-primary">
              {date} · {city} {country}
            </div>
          </div>
          <HtmlContentViewer className="pr-[2rem] text-textdark text-[0.8125rem] font-primary" html={description} />
        </div>
      </div>
    </div>
  )
}
